import LocationManagementDialog
  from "@/views/settings/locationManagement/locationManagementDialog/LocationManagementDialog.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { mapState } from 'vuex';

export default {
  name: "WingsManagement",
  components: {
    LocationManagementDialog,
    ConfirmDlg
  },
  data() {
    return {
      search: "",
      loading: false,
      disabled: false,
      headers: [
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Name'],
          align: "start",
          value: "name",
          width: 400
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Enabled'],
          align: "start",
          value: "isDisplayResidentDetails",
          sortable: false
        },
        {
          align: "end",
          value: "id",
          width: 100,
          sortable: false
        }
      ]
    }
  },
  created() {
    this.$store.dispatch("getCareAPIKey", this.facility.id);
  },
  computed: {
    eventWings() {
      return this.$store.state.eventLocationModule.eventWings;
    },
    ...mapState({
      facility() {
        return this.$store.state.facilityModule.selectedFacility;
      }
    })
  },
  methods: {
    openDialogAddWing() {
      this.$refs.locationManagementDialog.open("addWing", null);
    },
    updateWing(location) {
      this.$refs.locationManagementDialog.open("updateWing", location);
    },
    deleteWing(item) {
      if(item?.isDefault === true) return

      this.$refs.ConfirmDlg
        .open(null, this.$i18n.messages[this.$i18n.locale]['LocationManagement.DeleteMessage'].replace('[name]', item.name), false, '', {
          noButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Cancel'],
          yesButtonText: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Delete']
        })
        .then(async response => {
          if (response && response.agree) {
            await this.$store.dispatch("deleteEventLocation", item).then(async () => {
              await this.$store.dispatch("getCareLevels");
              this.$store.dispatch("getEventWings");

              this.$toast.open({
                message: this.$i18n.messages[this.$i18n.locale]['WingsManagement.WingSuccessfullyDeleted'],
                type: "success"
              });
            })
          }
        });
    }
  }
}